module.exports = __webpack_public_path__ + "static/media/water.dd4c3e28.svg";